import { company_name } from "@/i18n/variables";

const register = {
	// Section for domain collection card
	collection_card_section: {
		accept_domain_terms_and_conditions: {
			href: "https://www.tuxis.nl/voorwaarden-domeinnaam-registraties/",
			text: "Mit der Registrierung dieser Domainnamen erkläre ich, dass ich <a>die Allgemeinen Geschäftsbedingungen der Registrare</a> gelesen habe und akzeptiere.",
		},
		delete_all: "Alle löschen",
		discount: "Ihr Rabatt",
		edit: "Domainnamen bearbeiten",
		empty: {
			description: "Wählen Sie den gewünschten Domainnamen, indem Sie eine Suche durchführen.",
			title: "Keine Domainnamen ausgewählt",
		},
		error: {
			dns_records_not_saved:
				"Die DNS-Einträge sind noch nicht gespeichert worden. Bitte speichern Sie die DNS-Einträge, um sich zu registrieren.",
		},
		exc_vat: "Ohne MwSt.",
		price_trustee: "Stellvertreter-Preis",
		register: "Domainnamen registrieren",
		title: "Ausgewählte Domainnamen",
		total: "Gesamtpreis",
	},

	// Complete section
	complete_section: {
		actions: {
			edit: "Bearbeiten",
			register: "Registrierung",
			transfer: "Übertragung",
		},
		button_text: "Zu den Domainnamen",

		description: "Die folgenden Domainnamen wurden beantragt:",

		description_error:
			"Hinweis! Bei der Beantragung der Registrierung/des Umzugs ist ein Fehler aufgetreten. \nDie folgenden Domains sind betroffen:",
		dns: {
			failed: "DNS hinzufügen fehlgeschlagen",
			success: "DNS erfolgreich hinzugefügt",
		},
		info_alert:
			"Bitte beachten Sie! Dies bedeutet nicht, dass Ihre beantragten Domains bereits registriert sind. Sie erhalten eine E-Mail von uns, wenn der Antrag endgültig ist.",
		title: "Domainregistrierung ausstehend",
	},

	// DNS management section
	dns_management: {
		bttn_dns_fetch: "DNS abrufen",
		bttn_dns_select_template: "Vorlage auswählen",
		title: "DNS verwalten",
	},

	// Domain holder section
	domain_holder_section: {
		description: "Um eine neue Domain zu registrieren, werden einige Ihrer Angaben benötigt.",
		local_presence: {
			alert: {
				accept_risk_button: "Ich habe die Risiken verstanden und akzeptiert",
				description:
					"Die folgenden TLDs erfordern eine lokale Präsenz. Dies kann durch die Verwendung eines Stellvertreters umgangen werden.",
				risk_button: "Ansicht der Risiken",
				risk_description:
					"Indem Sie der Nutzung eines Stellvertreters zustimmen, erklären Sie, dass Sie die Risiken kennen und akzeptieren.",

				// When any change is made to the text of risk_overview, then this change MUST also be made in the order confirmation email templates in the backend.
				risk_overview: `
### Bei der Verwendung eines Stellvertreter (Proxy) zur Registrierung eines Domainnamens sind mehrere Risiken zu beachten:

- Die Anforderungen an die lokale Präsenz haben ihren Grund. Ihre Umgehung kann zu rechtlichen Problemen führen, sowohl für Sie als auch für den Bevollmächtigten.
- Es kann Unklarheit darüber herrschen, wer der tatsächliche Eigentümer des Domainnamens ist. In einigen Fällen kann der Treuhänder technisch gesehen als Eigentümer gelten, was zu Problemen führen kann, wenn Sie die Kontrolle über den Domainnamen behalten oder ändern möchten.
- Sie sind von der Vertrauenswürdigkeit und Integrität des Bevollmächtigten abhängig. Wenn diese Person oder Einrichtung beschließt, ihre Position zu missbrauchen, kann dies zum Verlust des Domainnamens oder zu anderen damit verbundenen Problemen führen.
- Ihr Domainname kann ein entscheidender Teil Ihrer Online-Präsenz sein. Wenn Sie einen Dritten beauftragen, führen Sie eine zusätzliche Verbindung ein, die zu Sicherheitsproblemen führen kann.
- Die Erneuerung und Verwaltung des Domainnamens wird komplizierter. Kommunikation und Koordination mit dem Treuhänder sind notwendig, was zu Verzögerungen, Missverständnissen und/oder Fehlern führen kann, die die Freigabe eines Domainnamens zur Folge haben können.
- Die Möglichkeit, Änderungen vorzunehmen oder Probleme im Zusammenhang mit dem Domainnamen zu lösen, kann eingeschränkt sein, da Sie auf die Zusammenarbeit und Verfügbarkeit des Treuhänders angewiesen sind.
- Wenn der Treuhänder in illegale oder unethische Aktivitäten verwickelt wird, kann Ihr Ruf beeinträchtigt werden, insbesondere wenn Ihr Domainname damit in Verbindung gebracht wird.

### Tuxis haftet in keiner Weise für direkte, indirekte oder Folgeschäden bei der Nutzung eines Bevollmächtigten für die Registrierung von Domainnamen.
`,
				risk_overview_title: "Risiken bei der Verwendung eines Stellvertreters",
				title: "Stellvertreter verwenden",
			},
			title: "Stellvertreter hinzufügen",
		},
		relation: {
			same_as_holder_error:
				"Die ausgewählte Beziehung ist der aktuelle Inhaber dieses Bereichs. Wählen Sie eine andere Beziehung.",
			title: "Beziehung auswählen",
		},
		relation_check: {
			title: "Daten zur Überprüfung",
		},
		title: "Domaininhaber wählen",
		tld_requirements: {
			address: {
				description: "Für die folgenden Domains sind zusätzliche Adressinformationen erforderlich:",
				title: "Zusätzliche Adressangaben erforderlich!",
			},
			business_only: {
				description:
					"Die folgenden Domainnamen können nur für Geschäftsbeziehungen registriert werden. Wählen Sie eine andere Relation oder löschen Sie den Domainnamen.",
				title: "Die folgenden Domains können nicht registriert werden",
			},
			company: {
				company_private_relation:
					"Da Sie eine private Beziehung ausgewählt haben, können Sie diese Daten nicht ausfüllen. Wählen Sie eine Geschäftsbeziehung oder entfernen Sie die folgenden Domain aus der Liste der zu registrierenden Domain (später registrieren):",
				description:
					"Für die folgenden Domains sind zusätzliche Unternehmensinformationen erforderlich:",
				title: "Zusätzliche Unternehmensinformationen erforderlich!",
			},
			personal_details: {
				description:
					"Für die folgenden Bereiche werden zusätzliche personenbezogene Daten benötigt:",
				title: "Zusätzliche persönliche Daten erforderlich!",
			},
			register_later_bttn: "Später registrieren",
			remove_domain_bttn: "Domain löschen",
			title:
				"Zusätzliche Daten erforderlich! Diese werden der ausgewählten Beziehung nach der Registrierung hinzugefügt.",
			trademark: {
				description: "Für die folgenden Domains sind Markeninformationen erforderlich:",
				title: "Zusätzliche Markeninformationen erforderlich!",
			},
		},
	},

	// Error messages
	error_messages: {
		transfer_domain:
			"Bei der Übertragung einer Domain ist ein Fehler aufgetreten. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an unseren Kundenservice.",
		update_relation_domain_details:
			"Bei der Verarbeitung der Daten der Beziehung ist ein Fehler aufgetreten. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an unseren Kundendienst.",
	},

	// Section for search results
	search_result_section: {
		domain_result_record: {
			available: "Verfügbar",
			months: "Monate",
			register: "Registrieren",
			taken: "Besetzt",
			transfer: "Übertragung",
			unavailable: "Nicht verfügbar",
			unavailable_price: "Preis nicht verfügbar",
		},
		title: "Gefundene Domainnamen",
	},

	// Section for searching domains
	search_section: {
		error_fetch_domain_purchase_info:
			"Beim Abrufen der Domainerweiterungsinformationen ist ein Fehler aufgetreten. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an unseren Kundendienst.",
		extension_unavailable: `Diese Erweiterung scheint nicht zu existieren. Möchten Sie, dass ${company_name} Sie wegen der Registrierung dieser Erweiterung kontaktiert?`,
		extension_unavailable_bttn: "Fehlermeldung senden",
		extension_unavailable_bttn_success: "Fehlermeldung erfolgreich gesendet",
		oxxa_unavailable:
			"Bitte beachten Sie! Zur Zeit ist es nicht möglich, den Domain-Status beim jeweiligen Provider abzufragen. Der Domainstatus kann sich nach der Registrierung ändern.",
		search_alternative_tlds_placeholder: "z.B. '.de'",
		search_placeholder: `z.B. ${company_name}.de`,
		sending_extension_unavailable_mail_failed:
			"Die Fehlermeldung konnte nicht gesendet werden. Bitte versuchen Sie es später noch einmal. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an unseren Kundendienst.",
		show_alternative_tlds: "Mehr Erweiterungen",
		title: "Wählen Sie Ihren Domainnamen",
	},
	// Titles
	titles: {
		edit: "Domainname bearbeiten",
		register: "Domainname registrieren",
	},

	transfer_token_section: {
		description:
			"Sie können den Übertragungscode bei der Partei anfordern, bei der Ihr Domainname derzeit registriert ist.",
		title: "Überweisungscode eingeben",
		token: "Übertragungscode",
	},
};

export default register;
